<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'app',
    mounted() {
      if (top !== self) {
        try {
          top.toLogout && top.toLogout();
        } catch (err) {
          console.log(err);
        }
      }
    }
  };
</script>

<style lang="scss">
  #app-login {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
